// extracted by mini-css-extract-plugin
export default {"header":"ApplicantInformationHeader_header__oXtEu"};